//let res = await fetch(https://k696orpcw2.execute-api.us-east-1.amazonaws.com/default/EbayITsearchAccessories?make=Porsche);
//https://k696orpcw2.execute-api.us-east-1.amazonaws.com/default/EbayITsearchAccessories?make=Porsche
async function getJson(url) {
    try {
        let res = await fetch(url);
        return await res.json();
    } catch (error) {
        console.log(error);
    }
}

export async function renderEbay() {
    let requestURL;
    let wrapper = document.querySelector('.ebay-widget');
    let makes = wrapper.dataset.makes;
    let models = wrapper.dataset.submodels;

    if (makes && makes.length > 0){
        makes = makes.split(',');
    }

    if (models && models.length > 0) {
        models = models.split(',');
    }

    if ( makes && makes.length > 0 && models && models.length > 0) {
        requestURL = `https://k696orpcw2.execute-api.us-east-1.amazonaws.com/default/EbayITsearchAccessories?make=${makes[0]}&model=${models[0]}`;
    } else if (makes && makes.length > 0 && !models) {
        requestURL = `https://k696orpcw2.execute-api.us-east-1.amazonaws.com/default/EbayITsearchAccessories?make=${makes[0]}`;
    } else {
        requestURL = `https://k696orpcw2.execute-api.us-east-1.amazonaws.com/default/EbayITsearchAccessories`;
    }
    
    let data = await getJson(requestURL);

    let htmlInner = `
        <div class="ebay-image">
            <img src="${data[0].image.imageUrl}" alt="${data[0].title}"> 
        </div>
        <div class="ebay-text">
            <a href="${data[0].itemAffiliateWebUrl}" target="_blank">
                ${data[0].title}
            </a>
            <span class="ebay-logo"></span>
        </div>`;

    wrapper.innerHTML = htmlInner;
}